import React from "react";
import { notification } from "antd";
import { CloseCircleOutlined } from '@ant-design/icons';


export const openErrorNotification = (description) => {
  notification.open({
    message: <span style={{ color: 'red', fontSize: 24 }}><CloseCircleOutlined style={{ fontSize: 24 }} /> Error</span>,
    description,
  })
}
